import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { querySnapshotToArray, TDR } from 'tdr-common';

export function useRestaurantBasePolicies(restaurantId: string | undefined) {
	const query = useQuery({
		queryKey: ['restaurantBasePolicies', restaurantId],
		queryFn: () => getRestaurantBasePolicies(restaurantId),
		enabled: !!restaurantId
	});
	return query;
}

export async function getRestaurantBasePolicies(restaurantId: string | undefined): Promise<TDR.PricingPolicy[]> {
	if (!restaurantId) {
		return [];
	}
	const db = getFirestore();
	const q = query(collection(db, 'PricingPolicies'), where('restaurantId', '==', restaurantId), where('active', '==', true));
	const querySnapshot = await getDocs(q);
	return querySnapshotToArray(querySnapshot) || [];
}